module.exports = __webpack_public_path__ + "static/media/company.1b6625e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company.svg
// module id = 712
// module chunks = 0